import { useLayoutEffect, RefObject } from 'react';

export function useUpdateTooltipPosition(
  yearRef: RefObject<HTMLElement | null>,
  tableContainerRef: RefObject<HTMLElement | null>,
  setTooltipPosition: (position: { top: number; left: number }) => void,
  selectedYear: string | number,
) {
  useLayoutEffect(() => {
    const updateTooltipPosition = () => {
      if (yearRef.current && tableContainerRef.current) {
        const rect = yearRef.current.getBoundingClientRect();
        const containerRect = tableContainerRef.current.getBoundingClientRect();
        const hasData = yearRef.current.getAttribute('data-hasyeardata') === 'true';

        if (hasData) {
          setTooltipPosition({
            top: rect.top - containerRect.top + rect.height - 20,
            left: rect.left - containerRect.left,
          });
        }
      }
    };

    updateTooltipPosition();

    const resizeObserver = new ResizeObserver(updateTooltipPosition);
    if (tableContainerRef.current) {
      resizeObserver.observe(tableContainerRef.current);
    }

    return () => {
      resizeObserver.disconnect();
    };
  }, [selectedYear, yearRef, tableContainerRef, setTooltipPosition]);
}
